import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
var _excluded = ["options", "size", "mode", "theme", "className", "value", "onChange", "placeholder", "isClearable", "isLoading", "isDisabled", "isSearchable", "noOptionsMessage", "placement", "boldLabel"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.function.name.js";
import React, { useRef, useState, useEffect, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import scrollIntoView from 'scroll-into-view-if-needed';
import { Dropdown } from '@rescui/dropdown';
import { Menu, MenuItem, Divider, GroupHeader } from '@rescui/menu';
import { useTheme } from '@rescui/ui-contexts';
import SelectTrigger from './parts/trigger.js';
import FormTriggerWrapper from './parts/form-trigger-wrapper.js';
import { optionType, optionsGroupType, noOptionsMessageConfigType } from './common-prop-types.js';
import { useStrongMemo, getDefaultCursorIndex, isGroupsEmpty, getMovedCursorIndex, shouldOpenSelect, isIndexMatchCursor, reverseTheme, getPlainOptionsFromGroups, getEmptyMessage, withoutGroupsLabel, OptionGroupTypes, getOptionValue, convertToOptionGroupsIfNeeded, escapeRegex, calculateMaxHeight } from './utils.js';
import { ARROW_DOWN, ARROW_UP, ENTER, SPACE, TAB, ESCAPE, BACKSPACE } from './key-codes.js';
import styles from './parts/common-select.p.module.css.js'; // eslint-disable-next-line complexity

var Option = function Option(_ref) {
  var groups = _ref.groups,
      selected = _ref.selected,
      cursorIndex = _ref.cursorIndex,
      size = _ref.size,
      item = _ref.item,
      isLastItem = _ref.isLastItem,
      highlightedItemRef = _ref.highlightedItemRef,
      handleSelectIndex = _ref.handleSelectIndex,
      handleHighlightIndex = _ref.handleHighlightIndex;
  var marginInPx = withoutGroupsLabel(groups) ? 0 : {
    l: 12,
    m: 6,
    s: 0
  }[size];

  if (item.type === OptionGroupTypes.OPTION) {
    var _context;

    var index = item.index,
        label = item.label;
    var value = getOptionValue(item);
    var isSelected = selected && value === getOptionValue(selected);
    var isHighlighted = isIndexMatchCursor(cursorIndex, index);
    return /*#__PURE__*/React.createElement(MenuItem, {
      selected: isSelected,
      highlighted: isHighlighted,
      ref: isHighlighted ? highlightedItemRef : null,
      onMouseMove: function onMouseMove() {
        return handleHighlightIndex(index);
      },
      onClick: function onClick() {
        return handleSelectIndex(index);
      },
      style: {
        marginBottom: isLastItem ? "".concat(marginInPx, "px") : ''
      },
      "data-test": _filterInstanceProperty(_context = ['select-menu-item', isHighlighted && 'select-menu-item-highlighted', isSelected && 'select-menu-item-selected']).call(_context, Boolean).join(' ')
    }, label);
  }

  if (item.type === OptionGroupTypes.DIVIDER) {
    return /*#__PURE__*/React.createElement(Divider, {
      style: {
        marginTop: "".concat(marginInPx, "px")
      }
    });
  }

  if (item.type === OptionGroupTypes.HEADER) {
    var _label = item.label;
    return /*#__PURE__*/React.createElement(GroupHeader, {
      text: _label
    });
  }

  return null;
};

var getOptionKey = function getOptionKey(item, i) {
  if (item.type === OptionGroupTypes.OPTION) {
    var _context2;

    var value = getOptionValue(item);
    return _concatInstanceProperty(_context2 = "".concat(value, "_")).call(_context2, item.index[0]);
  } else if (item.type === OptionGroupTypes.DIVIDER) {
    return "divider".concat(i);
  } else if (item.type === OptionGroupTypes.HEADER) {
    return "header".concat(i);
  }

  return null;
}; // eslint-disable-next-line complexity


var Select = function Select(_ref2) {
  var _context4;

  var options = _ref2.options,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 'm' : _ref2$size,
      _ref2$mode = _ref2.mode,
      mode = _ref2$mode === void 0 ? 'classic' : _ref2$mode,
      themeFromProps = _ref2.theme,
      _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? null : _ref2$className,
      _ref2$value = _ref2.value,
      value = _ref2$value === void 0 ? undefined : _ref2$value,
      onChange = _ref2.onChange,
      placeholder = _ref2.placeholder,
      _ref2$isClearable = _ref2.isClearable,
      isClearable = _ref2$isClearable === void 0 ? false : _ref2$isClearable,
      _ref2$isLoading = _ref2.isLoading,
      isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading,
      _ref2$isDisabled = _ref2.isDisabled,
      isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled,
      _ref2$isSearchable = _ref2.isSearchable,
      isSearchable = _ref2$isSearchable === void 0 ? false : _ref2$isSearchable,
      noOptionsMessage = _ref2.noOptionsMessage,
      _ref2$placement = _ref2.placement,
      placement = _ref2$placement === void 0 ? 'bottom' : _ref2$placement,
      boldLabel = _ref2.boldLabel,
      restProps = _objectWithoutProperties(_ref2, _excluded);

  var theme = useTheme(themeFromProps);
  var dropdownRef = useRef(null);
  var highlightedItemRef = /*#__PURE__*/React.createRef();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isKeyboardNavigating = _useState2[0],
      setIsKeyboardNavigating = _useState2[1];

  var skipScrollingRef = useRef(false);

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      searchString = _useState4[0],
      setSearchString = _useState4[1];

  var groups = useStrongMemo(function () {
    return convertToOptionGroupsIfNeeded(options);
  }, [options]);
  var filteredGroups = useStrongMemo(function () {
    if (searchString === '') {
      return groups;
    }

    var filter = new RegExp("(?:^|\\s)".concat(escapeRegex(searchString)), 'i');
    return _mapInstanceProperty(groups).call(groups, function (g) {
      var _context3;

      return _objectSpread(_objectSpread({}, g), {}, {
        options: _filterInstanceProperty(_context3 = g.options).call(_context3, function (_ref3) {
          var label = _ref3.label;
          return filter.test(label);
        })
      });
    });
  }, [searchString, groups]);

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      menuIsOpen = _useState6[0],
      setMenuIsOpen = _useState6[1];

  var _useState7 = useState(function () {
    return getDefaultCursorIndex(filteredGroups);
  }),
      _useState8 = _slicedToArray(_useState7, 2),
      cursorIndex = _useState8[0],
      setCursorIndex = _useState8[1];

  useEffect(function () {
    setCursorIndex(getDefaultCursorIndex(filteredGroups));

    if (searchString !== '') {
      setMenuIsOpen(true);
    }
  }, [searchString, filteredGroups]);
  var isEmptyMenu = useMemo(function () {
    return isGroupsEmpty(filteredGroups);
  }, [filteredGroups]);
  var handleSelectIndex = useCallback(function (index) {
    var _index = _slicedToArray(index, 2),
        grpIndex = _index[0],
        optIndex = _index[1];

    var selectedOption = filteredGroups[grpIndex].options[optIndex];
    setMenuIsOpen(false);
    setSearchString('');
    setIsKeyboardNavigating(false);

    if (onChange) {
      onChange(selectedOption);
    }
  }, [onChange, filteredGroups]);
  useEffect(function () {
    if (dropdownRef.current) {
      dropdownRef.current.scheduleUpdate();
    }
  }, [searchString]);
  var handleMouseMove = useCallback(function () {
    return setIsKeyboardNavigating(false);
  }, []);
  useEffect(function () {
    if (isKeyboardNavigating) {
      document.addEventListener('mousemove', handleMouseMove);
    }

    return function () {
      return document.removeEventListener('mousemove', handleMouseMove);
    };
  }, [handleMouseMove, isKeyboardNavigating]);
  useEffect(function () {
    if (isKeyboardNavigating && highlightedItemRef.current) {
      if (skipScrollingRef.current) {
        skipScrollingRef.current = false;
      } else {
        var elementToScrollTo = highlightedItemRef.current;

        if (cursorIndex[0] === 0 && cursorIndex[1] === 0) {
          var groupHeader = highlightedItemRef.current.previousSibling;

          if (groupHeader) {
            elementToScrollTo = groupHeader;
          }
        }

        scrollIntoView(elementToScrollTo, {
          behavior: 'instant',
          scrollMode: 'if-needed',
          block: 'nearest',
          inline: 'nearest'
        });
      }
    }
  }, [highlightedItemRef, cursorIndex, isKeyboardNavigating]);
  var handleClose = useCallback(function () {
    setSearchString('');
    setMenuIsOpen(false);
    setIsKeyboardNavigating(false);
  }, []);
  var handleKeyNavigation = useCallback( // eslint-disable-next-line complexity
  function (e) {
    if (e.key === ARROW_DOWN || e.key === ARROW_UP) {
      var isDownDirection = e.key === ARROW_DOWN;
      setCursorIndex(getMovedCursorIndex(filteredGroups, cursorIndex, isDownDirection));
      setIsKeyboardNavigating(true);
      e.preventDefault();
    }

    if (e.key === ENTER || !isSearchable && e.key === SPACE) {
      if (cursorIndex !== null) {
        handleSelectIndex(cursorIndex);
      } else {
        handleClose();
      }

      e.preventDefault();
    }

    if (e.key === TAB) {
      handleClose();
    }
  }, [filteredGroups, cursorIndex, handleClose, handleSelectIndex, isSearchable]);
  var handleClick = useCallback(function () {
    if (isDisabled) {
      return;
    }

    setMenuIsOpen(function (currentMenuIsOpen) {
      return !currentMenuIsOpen;
    });
    setSearchString('');
  }, [isDisabled]);
  var handleSearchInputChange = useCallback(function (searchValue) {
    return setSearchString(searchValue);
  }, []);
  var handleClearClick = useCallback(function () {
    setCursorIndex(getDefaultCursorIndex(filteredGroups));
    setMenuIsOpen(false);

    if (onChange) {
      onChange(null);
    }
  }, [filteredGroups, onChange]);
  var handleTriggerKeyDown = useCallback(function (e) {
    if (e.key === ESCAPE) {
      handleClose();
      e.preventDefault();
    }

    if (isDisabled) {
      return;
    }

    if (menuIsOpen) {
      handleKeyNavigation(e);
    } else {
      var target = e.target;
      var trigger = target.closest('[data-target="trigger"]');
      var isTriggerTarget = trigger === target;

      if (shouldOpenSelect(e.key, isTriggerTarget)) {
        setMenuIsOpen(true);
        setSearchString('');
        setIsKeyboardNavigating(true);
        skipScrollingRef.current = true;
        trigger.focus();
        e.preventDefault();
      }

      if (e.key === BACKSPACE && isClearable) {
        handleClearClick();
        trigger.focus();
        e.preventDefault();
      }
    }
  }, [menuIsOpen, isDisabled, isClearable, handleClose, handleClearClick, handleKeyNavigation]);
  var handleHighlightIndex = useCallback(function (index) {
    if (!isIndexMatchCursor(cursorIndex, index)) {
      setCursorIndex(index);
    }
  }, [cursorIndex]);
  var maxHeight = calculateMaxHeight(size);
  return /*#__PURE__*/React.createElement(Dropdown, {
    theme: theme,
    onRequestClose: handleClose,
    placement: placement,
    mode: mode,
    ref: dropdownRef,
    cancelCloseAnimation: true,
    minWidth: "trigger",
    maxWidth: "trigger",
    maxHeight: maxHeight,
    leastMaxHeight: maxHeight,
    disableFocusLock: true,
    trigger: function trigger(_ref4) {
      var ref = _ref4.ref;
      return /*#__PURE__*/React.createElement(FormTriggerWrapper, {
        className: className,
        theme: theme,
        size: size,
        error: restProps.error,
        label: restProps.label,
        note: restProps.note,
        onKeyDown: handleTriggerKeyDown,
        boldLabel: boldLabel
      }, restProps.name && /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: restProps.name,
        value: value && value.value || ''
      }), /*#__PURE__*/React.createElement(SelectTrigger, {
        theme: theme,
        mode: mode,
        size: size,
        isOpen: menuIsOpen,
        triggerRef: ref,
        selected: value,
        placeholder: placeholder,
        isClearable: isClearable,
        isLoading: isLoading,
        isDisabled: isDisabled,
        searchInput: searchString,
        isSearchable: isSearchable,
        onSearchChange: handleSearchInputChange,
        onClick: handleClick,
        onClearClick: handleClearClick,
        error: Boolean(restProps.error),
        id: restProps.id,
        "data-target": "trigger"
      }));
    },
    isOpen: menuIsOpen
  }, /*#__PURE__*/React.createElement(Menu, {
    size: size,
    theme: mode === 'rock' ? reverseTheme(theme) : theme,
    disableCursor: isKeyboardNavigating,
    className: styles.menu,
    enableKeyboardNavigation: false
  }, !isEmptyMenu ? _mapInstanceProperty(_context4 = getPlainOptionsFromGroups(filteredGroups)).call(_context4, function (item, i, collection) {
    return /*#__PURE__*/React.createElement(Option, {
      item: item,
      isLastItem: i === collection.length - 1,
      key: getOptionKey(item, i),
      groups: filteredGroups,
      selected: value,
      cursorIndex: cursorIndex,
      size: size,
      highlightedItemRef: highlightedItemRef,
      handleSelectIndex: handleSelectIndex,
      handleHighlightIndex: handleHighlightIndex
    });
  }) : /*#__PURE__*/React.createElement(MenuItem, {
    disabled: true
  }, getEmptyMessage(isLoading, isSearchable && searchString.length > 0, noOptionsMessage))));
};

Select.propTypes = {
  className: PropTypes.string,
  options: PropTypes.oneOfType([PropTypes.arrayOf(optionType), PropTypes.arrayOf(optionsGroupType)]),
  value: optionType,
  onChange: PropTypes.func,
  size: PropTypes.oneOf(['l', 'm', 's']),
  mode: PropTypes.oneOf(['classic', 'rock']),
  theme: PropTypes.oneOf(['light', 'dark']),
  placeholder: PropTypes.string,
  isClearable: PropTypes.bool,
  isSearchable: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),
  label: PropTypes.node,
  id: PropTypes.string,
  note: PropTypes.node,
  noOptionsMessage: PropTypes.oneOfType([PropTypes.string, noOptionsMessageConfigType]),
  placement: PropTypes.oneOf(['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start']),
  name: PropTypes.string
};
export { Select as default };
